import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home';
import Documents from './pages/Documents/ListDocuments';
import UploadDocument from './pages/Documents/UploadDocument';
import Login from './pages/Login/Login';
import UploadShapefile from "./pages/Shapefiles/UploadShapefile";
import UserForm from './pages/UserForm/UserForm';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import ResetPasswordConfirm from './pages/ResetPassword/ResetPasswordConfirm';
import Report from './pages/Report/Report';
import ListShapefile from './pages/Shapefiles/DownloadShapefile';
import ListAccessLog from './pages/AccessLog/ListAccessLog';
import ProductValidation from './pages/ProductValidation/ProductValidation';
import ReviewImport from './pages/ReviewImport/ReviewImport';

function App() {
	return (
		<>
			<Router>
				<Routes>
					<Route path="/" element={<Login />} />
					<Route path="/Home" element={<Home />} />
					<Route path="/documents" element={<Documents />} />
					<Route path="/upload" element={<UploadDocument />} />
					<Route path="/upload-shapefile" element={<UploadShapefile />} />
					<Route path="/user-form" element={<UserForm />} />
					<Route path="/reset-password" element={<ResetPassword />} />
					<Route path="/reset-password/confirm" element={<ResetPasswordConfirm />} />
					<Route path="/report" element={<Report />} />
					<Route path="/shapefiles" element={<ListShapefile />} />
					<Route path='/user-log' element={<ListAccessLog />} />
					<Route path="/product-validation" element={<ProductValidation />} />
					<Route path="/review-import" element={<ReviewImport />} />
				</Routes>
			</Router>
		</>
	);
}

export default App;
